import React, { useEffect, useState } from "react";
import "./style.scss";

import {
  Breadcrumb,
  Footer,
  Header,
  Sidebar,
} from "../../components";

import { Link } from "react-router-dom";

import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import BaseURL from "../../assets/utils/baseUrl";

function Berita() {

  useDocumentTitle(
    "Informasi - BAPENDA KOTA BEKASI"
  );

  // ====================================
  // STATE
  // ====================================

  const [informasi, setInformasi] = useState([]);

  const [informasiPerPage, setInformasiPerPage] =
    useState([]);

  const [pageNumber, setPageNumber] =
    useState([]);

  const [pageShow, setPageShow] =
    useState(0);

  const [loading, setLoading] =
    useState(true);

  const itemPerPageLength = 10;

  // ====================================
  // FETCH API
  // ====================================
const secureUrl = (url) => {
  if (!url) return "";

  return url.replace("http://", "https://");
};

  useEffect(() => {

    const controller = new AbortController();

    const getData = async () => {

      try {

        setLoading(true);

       const response = await fetch(
  BaseURL + "index.php/api/Berita?jumlah_item=10",
  {
    method: "GET",

    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",

      // ambil dari .env
      "X-API-KEY":
        process.env.REACT_APP_API_KEY
    },

    signal: controller.signal
  }
);

        // ====================================
        // VALIDASI RESPONSE
        // ====================================

        if (!response.ok) {

          throw new Error(
            "HTTP Error : " +
            response.status
          );
        }

        const result =
          await response.json();

        console.log(
          "API BERITA:",
          result
        );

        // ====================================
        // VALIDASI DATA
        // ====================================

        if (
          result &&
          result.status === true &&
          Array.isArray(result.data)
        ) {

          setInformasi(result.data);

        } else {

          setInformasi([]);
        }

      } catch (error) {

        if (
          error.name !== "AbortError"
        ) {

          console.error(
            "ERROR FETCH BERITA:",
            error
          );
        }

        setInformasi([]);

      } finally {

        setLoading(false);
      }
    };

    getData();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    // cleanup
    return () =>
      controller.abort();

  }, []);

  // ====================================
  // PAGINATION
  // ====================================

  useEffect(() => {

    if (
      !Array.isArray(informasi)
    ) return;

    const totalPage =
      Math.ceil(
        informasi.length /
        itemPerPageLength
      );

    const pages =
      Array.from(
        { length: totalPage },
        (_, i) => i
      );

    setPageNumber(pages);

    const start =
      pageShow *
      itemPerPageLength;

    const end =
      start +
      itemPerPageLength;

    setInformasiPerPage(
      informasi.slice(start, end)
    );

  }, [informasi, pageShow]);

  // ====================================
  // PAGE CHANGE
  // ====================================

  const pageChanger = (item) => {

    setPageShow(item);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // ====================================
  // RENDER
  // ====================================

  return (

    <div className="page">

      <Header active="publikasi" />

      <main className="main-sb">

        <section className="content">

          <Breadcrumb
            path="Publikasi / Berita"
          />

          <div className="page-title-wrapper">

            <div className="page-title">
              Berita Terkini
            </div>

          </div>

          {/* ======================= */}
          {/* LIST BERITA */}
          {/* ======================= */}

          <div className="informasi-list-wrapper">

            {
              loading ? (

                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  Loading...
                </div>

              ) : informasiPerPage &&
                informasiPerPage.length > 0 ? (

                informasiPerPage.map(
                  (item) => (

                    <div
                      className="informasi-list-item"

                      key={
                        item.id_berita
                      }
                    >

                      <div className="informasi-list-thumbnail-wrapper">

                       <img
  className="informasi-list-thumbnail"
  src={
    item.thumbnail
      ? secureUrl(item.thumbnail)
      : "/no-image.png"
  }
  alt={item.judul || "berita"}
  loading="lazy"
  onError={(e) => {
    e.target.src = "/no-image.png";
  }}
/>

                      </div>

                      <div className="informasi-list-informasi">

                        <div>

                          <p className="informasi-list-title">

                            {
                              item.judul ||
                              "-"
                            }

                          </p>

                          <p className="informasi-list-date">

                            {
                              item.created_date ||
                              "-"
                            }

                          </p>

                          <p className="informasi-list-desc">

                            {
                              item.konten
                                ? item.konten
                                    .replace(
                                      /(_newline)/g,
                                      " "
                                    )
                                    .substring(
                                      0,
                                      400
                                    )
                                : "-"
                            }

                            {" "} [ ... ]

                          </p>

                        </div>

                        <Link
                          to={
                            "/berita-detail/" +
                            (
                              item.id_berita ||
                              ""
                            )
                          }
                        >

                          <div className="informasi-list-desc link">
                            Selengkapnya
                          </div>

                        </Link>

                      </div>

                    </div>

                  )
                )

              ) : (

                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  Tidak ada data berita
                </div>

              )
            }

          </div>

          {/* ======================= */}
          {/* PAGINATION */}
          {/* ======================= */}

          {
            pageNumber.length > 1 && (

              <div className="pagination-wrapper">

                {
                  pageNumber.map(
                    (item, idx) => (

                      <div
                        key={idx}

                        className={
                          item === pageShow
                            ? "page-number page-number-active"
                            : "page-number"
                        }

                        onClick={() =>
                          pageChanger(item)
                        }
                      >
                        {item + 1}
                      </div>

                    )
                  )
                }

              </div>

            )
          }

        </section>

        <Sidebar />

      </main>

      <Footer />

    </div>
  );
}

export default Berita;